export const NAMESPACE_OPT_IN = "*NS*";
export const DEFAULT_AI_MODEL = "gpt-4o";
export const DEFAULT_AI_TEMPERATURE = 0.8;
export const JS_BEGINNING_OF_TIME_ISO = "-271821-04-20T00:00:00.000Z";
export const JS_END_OF_TIME_ISO = "+275760-09-13T00:00:00.000Z";
export const AI_MODEL_OPTIONS = [
  { value: "gpt-4o", label: "GPT-4o" },
  { value: "gpt-4", label: "GPT-4" },
  { value: "gpt-3.5-turbo", label: "GPT-3.5-turbo" },
];

export const MAPPING_TYPES = ["request", "response", "contact", "entities", "orgmodels", "delta", "custom"] as const;
export type MappingType = typeof MAPPING_TYPES[number];
